import { Navigate } from "react-router-dom";
import { PATH_DASHBOARD } from "./paths";
import PrivateRoute from "./PrivateRoute";
import HrmLegacyRedirect from "./HrmLegacyRedirect";
import {
  DepartmentsListPage,
  DepartmentFormPage,
  UserAccountPage,
  UserCreatePage,
  UserEditPage,
  DesiginationCreatePage,
  DesiginationEditPage,
} from "./elements";

export const hrmRoutes = [
  {
    path: "hrm",
    children: [
      {
        index: true,
        element: <Navigate to={PATH_DASHBOARD.user.root} replace />,
      },
      {
        path: "departments",
        children: [
          { index: true, element: <PrivateRoute component={DepartmentsListPage} permission="canViewStaff" /> },
          { path: "new", element: <PrivateRoute component={DepartmentFormPage} permission="canAddStaffAndRoles" /> },
          { path: ":departmentId/edit", element: <PrivateRoute component={DepartmentFormPage} permission="canEditStaffDetails" /> },
        ],
      },
      {
        path: "staff",
        children: [
          {
            index: true,
            element: (
              <PrivateRoute
                component={UserAccountPage}
                permission="canViewStaff"
              />
            ),
          },
          {
            path: "new",
            element: (
              <PrivateRoute
                component={UserCreatePage}
                permission="canAddStaffAndRoles"
              />
            ),
          },
          {
            path: ":id",
            element: (
              <PrivateRoute
                component={UserEditPage}
                permission="canViewStaff"
              />
            ),
          },
          {
            path: ":id/edit",
            element: <PrivateRoute component={UserEditPage} />,
          },
          {
            path: ":id/replicate",
            element: (
              <PrivateRoute
                component={UserEditPage}
                permission="canAddStaffAndRoles"
              />
            ),
          },
        ],
      },
      {
        path: "roles-and-permissions",
        children: [
          {
            index: true,
            element: (
              <PrivateRoute
                component={UserAccountPage}
                permission="canViewStaff"
              />
            ),
          },
          {
            path: "new",
            element: (
              <PrivateRoute
                component={DesiginationCreatePage}
                permission="canAddStaffAndRoles"
              />
            ),
          },
          {
            path: ":id",
            element: (
              <PrivateRoute
                component={DesiginationEditPage}
                permission="canViewStaff"
              />
            ),
          },
          {
            path: ":id/edit",
            element: (
              <PrivateRoute
                component={DesiginationEditPage}
                permission="canEditStaffDetails"
              />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "user",
    children: [
      { index: true, element: <HrmLegacyRedirect /> },
      ...[
        "list",
        "account",
        "profile",
        "cards",
        "new",
        ":id",
        ":id/profile",
        ":id/edit",
        ":id/replicate",
      ].map((legacyPath) => ({
        path: legacyPath,
        element: <HrmLegacyRedirect />,
      })),
    ],
  },

  {
    path: "desigination",
    children: [
      { index: true, element: <HrmLegacyRedirect /> },
      ...["new", ":id", ":id/edit"].map((legacyPath) => ({
        path: legacyPath,
        element: <HrmLegacyRedirect />,
      })),
    ],
  },
];
